import type { ReactNode } from 'react'
import { Button } from './Button'
import { Dialog } from './Dialog'
import styles from './ConfirmDialog.module.css'

export interface ConfirmDialogProps {
  open: boolean
  title: string
  /** State the consequence, not just the question. */
  message: ReactNode
  confirmLabel?: string
  cancelLabel?: string
  /** `danger` for anything that suspends, cancels or ends something. */
  tone?: 'primary' | 'danger'
  loading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

/**
 * Gate in front of a consequential action.
 *
 * Every state transition an admin can trigger — suspend, reject, start, end —
 * goes through one of these, so no single click changes a passenger's or
 * driver's day.
 */
export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'primary',
  loading = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      title={title}
      size="sm"
      busy={loading}
      footer={
        <>
          <Button variant="ghost" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={tone} onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className={styles.message}>{message}</div>
    </Dialog>
  )
}
